import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { format } from 'date-fns'
import InputLabel from '@mui/material/InputLabel'
import FormHelperText from '@mui/material/FormHelperText'
import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import AccessPeriodInputs from './AccessPeriodInputs'
import { GUEST_DURATION_OPTIONS, getGuestExpiresAt } from './helpers'

const CUSTOM_DATE = 'custom'

const GuestDurationInputs = ({
  duration,
  onDurationChange,
  date,
  onDateChange,
}: {
  duration: number | null
  onDurationChange: (value: number | null) => void
  date: string | Date | null
  onDateChange: (value: Date | null) => void
}) => {
  const { t } = useTranslation()
  const [now, setNow] = useState(() => new Date())

  // Подпись «доступ до HH:mm» не должна застывать, пока модалка открыта.
  useEffect(() => {
    if (!duration) return
    setNow(new Date())
    const timer = setInterval(() => setNow(new Date()), 30_000)
    return () => clearInterval(timer)
  }, [duration])

  return (
    <>
      <InputLabel sx={{ mb: 1 }}>{t('guest_duration')}</InputLabel>
      <ToggleButtonGroup
        color="primary"
        size="small"
        exclusive
        fullWidth
        value={duration ?? CUSTOM_DATE}
        onChange={(_, value) => {
          if (value === null) return
          onDurationChange(value === CUSTOM_DATE ? null : Number(value))
        }}
        sx={{ flexWrap: 'wrap' }}
      >
        {GUEST_DURATION_OPTIONS.map(({ minutes, labelKey }) => (
          <ToggleButton key={minutes} value={minutes} sx={{ textTransform: 'none' }}>
            {t(labelKey)}
          </ToggleButton>
        ))}
        <ToggleButton value={CUSTOM_DATE} sx={{ textTransform: 'none' }}>
          {t('guest_duration_custom')}
        </ToggleButton>
      </ToggleButtonGroup>
      {duration ? (
        <FormHelperText sx={{ mb: 3 }}>
          {t('guest_access_until', {
            time: format(new Date(getGuestExpiresAt(duration, now)), 'dd.MM.yy HH:mm'),
          })}
        </FormHelperText>
      ) : (
        <AccessPeriodInputs value={date} onChange={onDateChange} />
      )}
    </>
  )
}

export default GuestDurationInputs
